import styled from "@emotion/styled";
import { Badge } from "@/components/primitives/Badge";
import { Button } from "@/components/primitives/Button";
import { Drawer } from "@/components/overlays/Drawer";
import type { FilterDrawerProps } from "./FilterDrawer.types";

/* Exact compiled output of the pre-migration Tailwind utilities. */

const FilterDrawerTitleWrap = styled("span", {
  label: "AgenticFilterDrawer-titleWrap"
})({
  display: "inline-flex",
  alignItems: "center",
  gap: ".5rem"
});

const FilterDrawerFooterRow = styled("div", {
  label: "AgenticFilterDrawer-footerRow"
})({
  display: "flex",
  gap: ".5rem"
});

const FilterDrawerBody = styled("div", {
  label: "AgenticFilterDrawer-body"
})({
  display: "grid",
  gap: "1rem"
});

export function FilterDrawer({
  open,
  onOpenChange,
  onClose,
  title = "Filters",
  description,
  children,
  activeFiltersCount = 0,
  applyLabel = "Apply filters",
  resetLabel = "Reset all",
  onApply,
  onReset,
  applying,
  footerActions,
  className
}: FilterDrawerProps) {
  return (
    <Drawer
      open={open}
      onOpenChange={onOpenChange}
      onClose={onClose}
      title={
        <FilterDrawerTitleWrap>
          {title}
          {activeFiltersCount > 0 && <Badge tone="primary" count={activeFiltersCount} />}
        </FilterDrawerTitleWrap>
      }
      description={description}
      size="sm"
      preventClose={applying}
      className={className}
      footer={
        footerActions ?? (
          <FilterDrawerFooterRow>
            <Button variant="secondary" fullWidth onClick={onReset} disabled={applying}>
              {resetLabel}
            </Button>
            <Button fullWidth loading={applying} onClick={onApply}>
              {applyLabel}
            </Button>
          </FilterDrawerFooterRow>
        )
      }
    >
      <FilterDrawerBody>{children}</FilterDrawerBody>
    </Drawer>
  );
}
